import { ObjectSchema, object, string } from "yup";

// ------------- PERMIT REQUEST -------------
export type PermitRequest = {
  nis: string;
  mode: string;
  time?: string;
  datePermit: string;
  dateBack?: string;
  pickup: string;
  pickupStatus: string;
  notes?: string;
};

export const permitRequestSchema: ObjectSchema<PermitRequest> = object({
  nis: string().required(),
  mode: string().required(),
  time: string().optional(),
  datePermit: string().required(),
  dateBack: string().optional(),
  pickup: string().required(),
  pickupStatus: string().required(),
  notes: string().optional(),
});
// ------------- PERMIT REQUEST -------------
